/**
 * @fileoverview Root Reducer-Konfiguration für den NgRx Store.
 *
 * Dieses Modul kombiniert alle Feature-Reducer und konfiguriert Meta-Reducer
 * für den gesamten Application State Tree.
 */

import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { initialJfLibState, jfLibReducers } from '@adnova/jf-ng-components';
import { environment } from '@environments/environment';
import { AppState } from '../states/app.state';

/**
 * Initialer State für die gesamte Anwendung.
 *
 * Kombiniert initiale States aus JF-Library und anwendungsspezifischen Features.
 *
 * @constant
 * @type {AppState}
 */
export const initialAppState: AppState = {
  ...initialJfLibState,
};

/**
 * Map aller Feature-Reducer in der Anwendung.
 *
 * Kombiniert Reducer aus der JF-Library mit anwendungsspezifischen Reducern.
 *
 * @constant
 * @type {ActionReducerMap<AppState>}
 */
export const reducers: ActionReducerMap<AppState> = {
  ...jfLibReducers,
};

/**
 * Meta-Reducer für Logging von Actions und State-Änderungen.
 *
 * Dieser Meta-Reducer fungiert aktuell als Pass-Through, kann aber für
 * Debugging-Zwecke im Development-Modus erweitert werden.
 *
 * @param {ActionReducer<AppState>} reducer - Der zu umwickelnde Reducer
 * @returns {ActionReducer<AppState>} Der umwickelte Reducer
 */
export function logger(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return (state, action) => {
    return reducer(state, action);
  };
}

/**
 * Array von Meta-Reducern die auf den Store angewendet werden.
 *
 * Meta-Reducer werden nur im Development-Modus für Debugging angewendet.
 * In Produktion werden keine Meta-Reducer angewendet für optimale Performance.
 *
 * @constant
 * @type {MetaReducer<AppState>[]}
 */
export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [logger] : [];
